// Three Oaks Property Management - Client Configuration
import { FEATURES } from '../features.js';

export const TOG_PLUTOO_CONFIG = {
  // Client identification
  clientName: 'tog-plutoo',
  displayName: 'Three Oaks Property Management',
  
  // Branding configuration
  branding: {
    companyName: 'Three Oaks Property Management',
    shortName: 'Three Oaks',
    logo: '/uploads/logos/threeoaks-logo.png',
    logoAlt: 'Three Oaks Property Management Logo',
    favicon: '/favicon.jpg',
    
    // Theme colors
    primaryColor: '#2E7D32',      // Forest green
    secondaryColor: '#66BB6A',    // Light green
    accentColor: '#A5D6A7',       // Very light green
    backgroundColor: '#F1F8E9',   // Subtle green background
    textColor: '#1B5E20',         // Dark green text
    
    // Theme name for CSS classes
    theme: 'oak-theme',
    
    // Custom CSS variables
    customCss: {
      '--primary-color': '#2E7D32',
      '--secondary-color': '#66BB6A',
      '--accent-color': '#A5D6A7',
      '--background-color': '#F1F8E9',
      '--text-color': '#1B5E20',
    }
  },
  
  // Firebase configuration
  firebase: {
    projectId: process.env.REACT_APP_TOG_FIREBASE_PROJECT_ID,
    databaseURL: process.env.REACT_APP_TOG_FIREBASE_DATABASE_URL,
    apiKey: process.env.REACT_APP_TOG_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_TOG_FIREBASE_AUTH_DOMAIN,
    storageBucket: process.env.REACT_APP_TOG_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_TOG_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_TOG_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_TOG_FIREBASE_MEASUREMENT_ID
    // Note: All Firebase configuration must be provided via environment variables
    // See ENVIRONMENT_VARIABLES_GUIDE.md for required variables
  },
  
  // Domain and deployment configuration
  deployment: {
    domain: 'threeoaks.plutoo.co.uk',
    ftpPath: '/public_html/threeoaks',
    buildPath: './build-tog-plutoo/',
  },
  
  // Client-specific feature overrides
  // These override the global feature flags for this client
  features: {
    // Core features (inherited from global config)
    // Tenant Portal is now a core feature - always enabled
  },
  
  // Client-specific customizations
  customizations: {
    // UI/UX customizations
    showAdvancedFilters: true,
    maxPropertiesPerPage: 50,
    enablePropertyGroups: true,
    showPropertyImages: true,
    defaultSortOrder: 'property_name',
    
    // Dashboard customizations
    dashboardWidgets: [
      'property_overview',
      'recent_maintenance',
      'rent_summary',
      'upcoming_tasks'
    ],
    
    // Navigation customizations
    sidebarCollapsed: false,
    showQuickActions: true,
    
    // Financial settings
    currencySymbol: '£',
    currencyCode: 'GBP',
    dateFormat: 'DD/MM/YYYY',
    
    // Property management specific
    allowMultipleLeases: true,
    requirePropertyPhotos: true,
    autoGeneratePropertyCodes: true,
    propertyCodePrefix: 'TOG',
    
    // Tenant management
    requireTenantReferences: true,
    allowJointTenancies: true,
    autoSendWelcomeEmails: false,
    
    // Maintenance settings
    allowTenantMaintenanceRequests: true,
    requireMaintenancePhotos: false,
    autoAssignMaintenanceToPreferredContractors: true,
    
    // Notification preferences
    emailNotifications: {
      newTenant: true,
      maintenanceRequest: true,
      rentOverdue: true,
      certificateExpiry: true,
    },
    
    // Reporting preferences
    defaultReportPeriod: 'monthly',
    includeVATInReports: true,
    showProfitLossReports: true,
  },
  
  // Client-specific menu structure
  menuStructure: {
    dashboard: { enabled: true, order: 1 },
    properties: { enabled: true, order: 2 },
    tenants: { enabled: true, order: 3 },
    calendar: { enabled: true, order: 4 },
    maintenance: { enabled: true, order: 5 },
    finance: { enabled: true, order: 6 },
    reports: { enabled: true, order: 7 },
    messages: { enabled: true, order: 8 },
    settings: { enabled: true, order: 9 },
  },
  
  // Client contact information
  support: {
    email: 'support@threeoaks.plutoo.co.uk',
    phone: '+44 (0) 1234 567890',
    hours: 'Monday - Friday, 9:00 AM - 5:00 PM GMT',
  },
  
  // Terms and compliance
  legal: {
    termsOfService: '/terms-threeoaks',
    privacyPolicy: '/privacy-threeoaks',
    dataRetentionPeriod: '7 years',
    gdprCompliant: true,
  }
}; 